import React from 'react';

function StrongTitleEmdash(props) {
    return <h1><strong>{props.children} &mdash;</strong></h1>
}

export default StrongTitleEmdash;